(function() { window.GUID_f858dbaf_c1f8_4cf1_bff9_9fe3274c6912 = { getGuid: function() { return "f858dbaf-c1f8-4cf1-bff9-9fe3274c6912"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatPeriod;
        (function (StatPeriod) {
            StatPeriod[StatPeriod["Season"] = 0] = "Season";
            StatPeriod[StatPeriod["Weekly"] = 1] = "Weekly";
        })(StatPeriod = Enumeration.StatPeriod || (Enumeration.StatPeriod = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatPeriod.pre.js.map
